import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Iconmark as Icon } from 'src/shared/components/icons/logos/iconmark'
import { SubscriptionPlan } from 'src/shared/features/subscriptions/schemas/subscriptions'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { cn } from 'src/shared/utils/cn'

export const SubscriptionLogo = () => {
  const { data: user } = useMyUserData()
  const isMobile = useIsMobile()
  const currentSubscription = user?.subscription ? user.subscription.plan : SubscriptionPlan.ROOKIE

  const subscriptionText = useMemo(() => {
    if (currentSubscription === SubscriptionPlan.ROOKIE) {
      return 'Rookie'
    }

    if (currentSubscription === SubscriptionPlan.PRO) {
      return 'Pro'
    }

    if (currentSubscription === SubscriptionPlan.EXPERT) {
      return 'Expert'
    }

    return 'Conrad'
  }, [currentSubscription])

  return (
    <div className={cn('flex w-full flex-row items-center justify-start', !isMobile && 'pl-4')}>
      <Link to={paths.home.getHref()} className="flex items-center justify-start gap-2 pt-0">
        <Icon className="size-7" />
        <span className="font-accent text-[28px] font-bold">{subscriptionText}</span>
      </Link>
      {currentSubscription === SubscriptionPlan.ROOKIE && (
        <Link
          to={paths.subscriptions.getHref()}
          className="ml-3 flex h-[25px] items-center justify-center rounded-[4px] border border-points px-[10px] py-[6px] text-xs font-medium text-points"
        >
          Upgrade
        </Link>
      )}
    </div>
  )
}

SubscriptionLogo.displayName = 'SubscriptionLogo'
